import type { InformativaPrivacy } from '@facile-it/shark-morph/components'
import { FieldFormatter } from '@facile-it/shark-morph/components'
import React from 'react'

export const informativaPrivacyBuilder = (): InformativaPrivacy.Props => ({
    intro: (
        <React.Fragment>
            <FieldFormatter.Empathize>Prendo atto</FieldFormatter.Empathize> e dichiaro di aver letto l&apos;informativa
            ai sensi dell&apos;art. 13 del regolamento UE 679/2016. Acconsento al trattamento dei miei dati per le
            finalità ivi descritte.
        </React.Fragment>
    ),
    body: (
        <React.Fragment>
            <section>
                <h4>
                    <u>
                        Informativa privacy (di seguito, “Informativa”) per i candidati ai sensi dell&apos;art. 13 del
                        Regolamento (UE) 679/2016 (di seguito, “Regolamento” o “GDPR”)
                    </u>
                </h4>
                <p>
                    La informiamo che la presente Informativa è resa ai sensi dell&apos;art. 13 del Regolamento nei
                    confronti di soggetti interessati che si candidano per la collaborazione lavorativa. Il Titolare del
                    trattamento è Facile.it Broker di assicurazioni S.p.A., P. IVA 08007250965, con sede legale in Via
                    Sannio, 3 – 20137 Milano (di seguito, “<b>Titolare</b>
                    ”). Il Responsabile per la protezione dei dati personali (di seguito, “<b>DPO</b>”) è contattabile
                    all&apos;indirizzo e-mail:{' '}
                    <FieldFormatter.Color color="primary">
                        <a href="mailto:dpo@facile.it">dpo@facile.it</a>
                    </FieldFormatter.Color>
                    .
                </p>
            </section>

            <section>
                <h4>Categorie e tipi di dati oggetto del trattamento</h4>
                <p>I dati personali trattati dal Titolare possono includere:</p>
                <ol>
                    <li>
                        dati comuni, quali informazioni personali (per esempio: nome, cognome, data di nascita,
                        indirizzo, immagine, sesso, stato civile, codice fiscale, ecc.), informazioni di contatto (per
                        esempio: numero di telefono fisso e/o mobile, indirizzo e-mail, ecc.), dati lavorativi e
                        professionali;
                    </li>
                    <li>
                        attraverso il Suo curriculum o successivamente, il Titolare potrebbe raccogliere dati
                        “particolari” come definiti all&apos;art. 9 del GDPR, ossia idonei a rivelare l&apos;origine
                        razziale ed etnica, le convinzioni religiose, le opinioni politiche, l&apos;adesione a partiti
                        politici, l&apos;adesione a sindacati, associazioni od organizzazioni a carattere religioso,
                        filosofico, nonché lo stato di salute (ad esempio: appartenenza alle cosiddette categorie
                        protette).
                    </li>
                </ol>
            </section>

            <section>
                <h4>Finalità e base giuridica del trattamento dei dati personali</h4>
                <p>
                    I dati che vengono da Lei forniti tramite l&apos;invio del curriculum o successivamente saranno
                    trattati per le seguenti finalità:
                </p>
                <ol>
                    <li>
                        valutare la coerenza del Suo profilo rispetto alle posizioni lavorative aperte, e in generale
                        gestire le procedure di selezione dei collaboratori;
                    </li>
                    <li>
                        procedere al contatto al fine di programmare colloqui che si rendano necessari, utilizzando i
                        dati di contatto da Lei forniti.
                    </li>
                </ol>
                <p>
                    La base legale del trattamento dei Suoi dati personali per le finalità sopra indicate sono gli artt.
                    6.1.a), 6.1.b) e 6.1.f) del GDPR, ossia il legittimo interesse del titolare a verificare
                    l&apos;idoneità del candidato a ricoprire la specifica posizione aperta.
                </p>
                <p>
                    Il conferimento dei Suoi dati personali per le finalità sopra indicate è facoltativo, ma
                    l&apos;eventuale mancato conferimento comporterebbe l&apos;impossibilità per il Titolare di valutare
                    il Suo profilo o di poter programmare colloqui.
                </p>
                <p>
                    In caso di accettazione della domanda di collaborazione, i dati personali che La riguardano saranno
                    trattati dal Titolare in base all&apos;informativa privacy predisposta per dipendenti e/o
                    collaboratori.
                </p>
                <p>
                    L&apos;eventuale trattamento di dati particolari potrà avvenire ai sensi dell&apos;art. 9.2.a) del
                    GDPR, solo previo Suo esplicito consenso e in conformità alle autorizzazioni pro tempore vigenti in
                    materia di protezione dei dati personali. A tal proposito, se non strettamente necessario, Le
                    chiediamo di non fornire tale tipo di informazioni; in caso contrario, qualora decidesse di
                    fornirle, Le verrà richiesto di rilasciare un apposito consenso in ottemperanza alla vigente
                    normativa in materia di protezione dei dati personali. In mancanza del rilascio da parte Sua del
                    consenso al trattamento dei dati particolari, qualora fornisca tale tipo di dati, questi non
                    potranno essere considerati ai fini della Sua candidatura.
                </p>
                <p>
                    È altresì possibile il verificarsi di un trattamento dei dati personali di terzi soggetti inviati al
                    Titolare. Rispetto a tale ipotesi, Lei si pone come autonomo titolare del trattamento, assumendosi
                    tutti gli obblighi e le responsabilità di legge. In tal senso, Lei conferisce sul punto la più ampia
                    manleva rispetto ad ogni contestazione, pretesa, richiesta di risarcimento del danno da trattamento,
                    ecc. che dovesse pervenire al Titolare da terzi soggetti i cui dati personali siano stati trattati
                    attraverso il Suo invio spontaneo in violazione delle norme sulla tutela dei dati personali
                    applicabili. In ogni caso, qualora Lei fornisca o in altro modo tratti dati personali di terzi,
                    garantisce fin da ora – assumendosene ogni connessa responsabilità – che tale particolare ipotesi di
                    trattamento si fonda su un&apos;idonea base giuridica che legittima il trattamento delle
                    informazioni in questione.
                </p>
            </section>

            <section>
                <h4>Conservazione dei dati personali</h4>
                <p>
                    I Suoi dati saranno conservati per un periodo di 12 mesi dal loro conferimento, e potranno essere
                    utilizzati per contatti ed eventuali colloqui futuri. Al termine di tale periodo, i Suoi dati
                    verranno cancellati in via definitiva.
                </p>
            </section>

            <section>
                <h4>Destinatari dei dati personali</h4>
                <p>I Suoi dati potranno essere condivisi con:</p>
                <ol>
                    <li>
                        soggetti che agiscono tipicamente in qualità di responsabili del trattamento ai sensi
                        dell&apos;art. 28 del GDPR;
                    </li>
                    <li>personale incaricato del trattamento ai sensi dell&apos;articolo 29 del GDPR;</li>
                    <li>
                        soggetti, enti o autorità, autonomi titolari del trattamento, a cui sia obbligatorio comunicare
                        i dati personali in forza di disposizioni di legge o di ordini delle autorità.
                    </li>
                </ol>
                <p>
                    I dati potranno essere accessibili alle altre aziende del Gruppo per le medesime finalità di cui
                    sopra e/o per finalità amministrativo-contabili ai sensi all&apos;art. 6 ed ai Considerando 47 e 48
                    del Regolamento.
                </p>
                <p>
                    L&apos;elenco aggiornato e completo dei responsabili è disponibile presso il Titolare e può essere
                    richiesto a quest’ultimo ai recapiti sopra indicati.
                </p>
            </section>

            <section>
                <h4>Trasferimento dei dati extra UE</h4>
                <p>
                    Per quanto concerne l&apos;eventuale trasferimento dei dati verso Paesi Terzi, il Titolare rende
                    noto che il trattamento avverrà secondo una delle modalità consentite dalla legge vigente, quali ad
                    esempio il consenso dell&apos;interessato, l&apos;adozione di Clausole Standard approvate dalla
                    Commissione Europea, la selezione di soggetti aderenti a programmi internazionali per la libera
                    circolazione dei dati od operanti in Paesi considerati sicuri dalla Commissione Europea. È possibile
                    avere maggiori informazioni, su richiesta, presso il Titolare ai recapiti sopra indicati.
                </p>
            </section>

            <section>
                <h4>Diritti degli interessati</h4>
                <p>
                    Ai sensi degli artt. 15-22 del GDPR, Lei ha il diritto di accedere in qualunque momento ai dati che
                    La riguardano; potrà inoltre chiedere la rettifica, la cancellazione, la limitazione del trattamento
                    dei dati stessi nei casi previsti dall&apos;art. 18 del GDPR, la revoca del consenso, ottenere la
                    portabilità dei dati che La riguardano nei casi previsti dall&apos;art. 20 del GDPR, nonché proporre
                    reclamo all&apos;autorità di controllo competente ex articolo 77 del GDPR (Garante per la Protezione
                    dei Dati Personali).
                </p>
                <p>
                    Lei può formulare una richiesta di opposizione al trattamento dei Suoi dati ex articolo 21 del GDPR,
                    nella quale dare evidenza delle ragioni che giustifichino l&apos;opposizione: il Titolare si riserva
                    di valutare la Sua istanza, che non verrebbe accettata in caso di esistenza di motivi legittimi
                    cogenti per procedere al trattamento che prevalgano sui Suoi interessi, diritti e libertà.
                </p>
                <p>
                    Tutte le richieste devono essere rivolte per iscritto al Titolare ovvero al DPO, ai recapiti sopra
                    indicati.
                </p>
                <p>
                    Il sottoscritto in calce identificato dichiara di avere ricevuto, letto e compreso completa
                    informativa ai sensi dell&apos;art. 13 del GDPR.
                </p>
                <p>
                    Le ricordiamo che può rimuovere i Suoi dati sensibili dal curriculum, poiché non ha l&apos;obbligo
                    di comunicarceli. Tuttavia, se ritiene che siano necessari ai fini della candidatura, deve
                    acconsentire al loro trattamento; diversamente, non potremo trattarli.
                </p>
            </section>
        </React.Fragment>
    ),
})
